export const env = {
    GOOGLE_SITE_KEY: '6Le4WAkTAAAAANEjkHV5UYNmpSUKLErQJv-AOf02',
  };